<template>
  <div class="box">
    <div class="box-body">
      <div class="row m-b-15 center-block">
        <div class="col-xs-12">
          <br />
          <div class="box-body form-left">
            <div>
              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>單位名稱</span>
                <input class="form-control" placeholder="" type="text" v-model="designated.unit" maxlength="45">
              </div>
              <br />
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>廠區名稱</span>
                <input class="form-control" placeholder="" type="text" v-model="designated.branch" maxlength="45">
              </div>
              <br />
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>電話</span>
                <input class="form-control" placeholder="" type="text" v-model="designated.tel">
              </div>
              <br />
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>地址</span>
                <input class="form-control" placeholder="" type="text" v-model="designated.address" maxlength="45">
              </div>
              <br />
            </div>
            <div>
              <div class="input-group">
                  <span class="input-group-addon">
                    <span class="text-red">＊ </span>公司型態
                  </span>
                <div>
                  <multiselect
                          v-model="designated.type"
                          :options="typeOption"
                          :searchable="true"
                          :allow-empty="false"
                          :close-on-select="true"
                          placeholder="公司型態"
                          :show-labels="false"
                          :multiple="false"
                          label="label"
                          track-by="label"
                  >
                  </multiselect>
                </div>
              </div>
              <br />
              <div>
                <div class="input-group">
                    <span class="input-group-addon">
                      <span class="text-red">＊ </span>擁有者
                    </span>
                  <div v-if="getRoleType === 99 && !up">
                    <multiselect
                            v-model="designated.owner"
                            :options="ownerTypeOptions"
                            :searchable="true"
                            :allow-empty="false"
                            :close-on-select="true"
                            placeholder="擁有者"
                            :show-labels="false"
                            :multiple="false"
                            label="label"
                            track-by="label"
                    >
                    </multiselect>
                  </div>
                  <div class="form-control form-info" v-else>
                    {{designated.owner.label}}
                  </div>
                </div>
                <br>
              </div>
              <br>
            </div>
          </div>
          <div class="box-body form-right">
            <div>
              <div class="input-group">
                <span class="input-group-addon">
                  <span class="text-red">＊ </span>參與品牌
                </span>
                <div v-if="(getRoleType === 99 || getRoleType === 30) && !up">
                  <multiselect
                          v-model="brandSelect"
                          :options="brandBrief"
                          :searchable="true"
                          :allow-empty="false"
                          :close-on-select="true"
                          placeholder="品牌"
                          :show-labels="false"
                          :multiple="false"
                          label="label"
                          track-by="label"
                          @input="getStore"
                  >
                  </multiselect>
                </div>
                <div class="form-control form-info" v-else>
                  {{brandSelect.label}}
                </div>
              </div>
              <br>
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon">
                  <span class="text-red">＊ </span>參與店家
                </span>
                <div v-if="(getRoleType === 99 || getRoleType === 30) && !up">
                  <multiselect
                          v-model="storeSelect"
                          :options="addStoresSetting.options"
                          :searchable="true"
                          :allow-empty="false"
                          :close-on-select="true"
                          placeholder="店家"
                          :show-labels="false"
                          :multiple="false"
                          label="label"
                          track-by="label"
                          @input="getStore"
                  >
                  </multiselect>
                </div>
                <div class="form-control form-info" v-else>
                  {{storeSelect.label}}
                </div>
              </div>
              <br>
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>統一編號</span>
                <input class="form-control" placeholder="" type="text" v-model="designated.ein" maxlength="45">
              </div>
              <br />
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>窗口名稱</span>
                <input class="form-control" placeholder="" type="text" v-model="designated.contact_name" maxlength="45">
              </div>
              <br />
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>窗口電話</span>
                <input class="form-control" placeholder="" type="text" v-model="designated.contact_phone" maxlength="45">
              </div>
              <br />
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>窗口email</span>
                <input class="form-control" placeholder="" type="text" v-model="designated.contact_email" maxlength="45">
              </div>
              <br />
            </div>
          </div>
        </div>
      </div>
      <div class="box-footer text-center">ˋ
        <button class="btn btn-fail" @click="$router.go(-1)">
          取消
        </button>
        <button class="btn btn-success" @click="checkDesigned" v-if="up">
          修改
        </button>
        <button class="btn btn-success" @click="checkDesigned" v-else>
          新增
        </button>
      </div>
    </div>
  </div>

</template>

<script>
import datetimePicker from 'vue-datepicker/vue-datepicker-es6.vue'
// Require needed datatables modules
import 'datatables.net'
import 'datatables.net-bs'
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
export default {
  props: {
    info: Object
  },
  components: {
    'date-time-picker': datetimePicker
  },
  data () {
    return {
      delOption: {
        id: 'delModal',
        title: '刪除活動',
        body: '確定刪除活動?<br>',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'delActivity'
          }
        ]
      },
      up: false,
      activityMethod: 1,
      // modal test
      orderType: [
        {label: '一般單', value: 1},
        {label: '團購單 - 團長', value: 2},
        {label: '團購單 - 團員', value: 3}
      ],
      orderMethod: [
        {label: '當日單', value: 1},
        {label: '預訂單', value: 2}
      ],
      coupon: {
        type: {label: '固定起迄時間', value: 1},
        price_type: {label: '免稅', value: 1},
        discount_type: {label: '折扣金額', value: 1},
        setting: {label: '依訂單購買商品數設定', value: 1},
        useType: {label: '品牌型', value: 2}
      },
      otherCoupon: [],
      // end
      otherCouponList: [
        {label: 'Nidin優惠券', value: 1, code: '1231231dz'},
        {label: '柴犬優惠券', value: 2, code: '324efxde'},
        {label: '你好優惠券', value: 3, code: '654trrgxx'}
      ],
      addStoresSetting: {
        class: 'buy-add-store',
        options: [],
        choose: []
      },
      /*
      addStoresExceptionSetting: {
        class: 'add-ex-store',
        options: [],
        choose: []
      },
      */
      deadType: [
        {label: '固定起迄時間', value: 'all_fixed'},
        {label: '固定結束時間', value: 'day_fixed'},
        {label: '發送日幾天後', value: 'day_day'}
      ],
      discountType: [
        {label: '折扣金額', value: 1}
        // {label: '折數', value: 2}
      ],
      couponSetting: [
        {label: '依訂單購買商品數設定', value: 'SC00001'},
        {label: '依個人訂單消費特定商品數', value: 'SC00002'},
        {label: '依個人訂單購買金額', value: 'SC00003'}
      ],
      useType: [
        {label: '品牌型', value: 2},
        {label: '門市型', value: 3}
      ],
      typeOption: [
        {label: '民營機關', value: 1},
        {label: '公家機關', value: 2},
        {label: '企業內部規劃', value: 3}
      ],
      usageValue: [],
      brandList: [],
      content: {
        bindingStoreList: [],
        bindingBrandList: [],
        bindingProdList: []
      },
      brandDefault: '',
      brandBrief: [],
      storeBrief: [],
      scheduleTime: '',
      show: {
        back: false
      },
      menuId: 0,
      menuName: '',
      storeId: 0,
      designated: {
        owner: {label: '品牌', value: 1},
        unit: '',
        branch: '',
        tel: '',
        address: '',
        type: {label: '民營機關', value: 1},
        ein: '',
        contact_name: '',
        contact_phone: '',
        contact_email: ''
      },
      productBrief: [],
      productChoseBrief: [],
      nowTime: moment().format('YYYY-MM-DD HH:mm'),
      // new
      ownerTypeOptions: [
        {label: '品牌', value: 1},
        {label: '門市', value: 2},
        {label: '平台', value: 3}
      ],
      aStoreList: [],
      aStoreOption: [],
      brandSelect: {
        label: '',
        value: ''
      },
      storeSelect: {},
      brandSelectMuti: [],
      setInfoTimes: 0
    }
  },
  created () {
    this.getBrandBrief()
    if (this.$route.name.indexOf('up') > -1) this.up = true
    // owner_type 和 owner_id 設定
    if (this.getRoleType === 30) this.designated.owner = {label: '品牌', value: 1}
    else if (this.getRoleType === 10) {
      this.designated.owner = {label: '門市', value: 2}
    }
  },
  methods: {
    ...mapActions(['setMenuStartTime', 'setMenuEndTime']),
    trigger (event) {
      if (event === 'delActivity') this.delActivity()
    },
    delActivity () {
      var self = this
      var url = '/activity/' + this.$route.params.activity_id + '/orderCouponComplete'
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.$router.replace('/upCouponTable')
        }
      })
    },
    getStoreBrief (brandId, last) {
      var self = this
      if (self.designated.owner.value !== 2) self.addStoresSetting.options = [{ label: '全部', value: 0 }]
      else self.addStoresSetting.options = []
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list
          for (let i = 0; i < sList.length; i++) {
            let obj = {label: sList[i].name, value: sList[i].store_id}
            self.storeBrief.push(obj)
            self.addStoresSetting.options.push(obj)
            if (self.getRoleType === 10) self.storeSelect = obj
          }
          if (self.info.id && self.setInfoTimes && last) self.setStore()
          else if (self.getRoleType === 10) {
            self.addStoresSetting.choose.push(self.addStoresSetting.options[0].value)
          }
        }
      })
    },
    getBrandBrief () {
      var self = this
      var url = '/brand/listBrief?is_delete=0&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list
          for (let i = 0; i < bList.length; i++) {
            let obj = {label: bList[i].name, value: bList[i].brand_id}
            self.brandBrief.push(obj)
          }
          if (self.$route.name.indexOf('up') > -1 && self.info.id && !self.setInfoTimes) {
            self.setInfo()
          } else if (self.getRoleType === 10 || self.getRoleType === 30) {
            self.brandSelect = self.brandBrief[0]
            self.getStore()
          }
        }
      })
    },
    getStore () {
      this.aStoreOption = []
      this.storeBrief = []
      this.addStoresSetting.options = []
      this.addStoresSetting.choose = []
      this.brandList = []
      if (this.brandSelect.value) this.getStoreBrief(this.brandSelect.value, true)
      this.brandList.push(this.brandSelect)
    },
    checkDesigned () {
      const dInfo = this.designated
      var msg = ''
      if (!dInfo.unit) msg = '單位名稱未填'
      else if (!dInfo.branch) msg = '廠區名稱未填'
      else if (!dInfo.tel) msg = '電話未填'
      else if (!dInfo.address) msg = '地址未填'
      else if (!dInfo.type.value) msg = '公司型態未填'
      else if (!dInfo.owner.value) msg = '擁有者未填'
      else if (!dInfo.ein) msg = '統一編號未填'
      else if (this.checkEin) msg = '統一編號格式錯誤'
      else if (!dInfo.contact_name) msg = '窗口名稱未填'
      else if (!dInfo.contact_phone) msg = '窗口電話未填'
      else if (!dInfo.contact_email) msg = '窗口email未填'
      this.getToast(msg)
    },
    setInfo () {
      const self = this
      this.designated = {
        owner: this.ownerTypeOptions.find(function (ot) { return ot.value === self.info.owner }),
        unit: this.info.unit,
        branch: this.info.branch,
        tel: this.info.tel,
        address: this.info.address,
        type: this.typeOption.find(function (t) { return t.value === self.info.type }),
        ein: this.info.ein,
        contact_name: this.info.contact_name,
        contact_phone: this.info.contact_phone,
        contact_email: this.info.contact_email
      }
      this.brandBrief.find(function (brand) {
        if (brand.value === self.info.brand_id) self.brandSelect = brand
      })
      this.addStoresSetting.options.find(function (store) {
        if (store.value === self.info.store_id) self.storeSelect = store
      })
      this.setInfoTimes++
    },
    getToast (msg) {
      if (msg) {
        this.$notify({
          title: '提醒',
          text: msg,
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else this.setData()
      /*
      // 測試
      if (tab) this.cMethod = index
      else this.setData()
      */
    },
    setData () {
      const dInfo = this.designated
      const data = {
        owner: dInfo.owner.value,
        unit: dInfo.unit,
        branch: dInfo.branch,
        tel: dInfo.tel,
        address: dInfo.address,
        type: dInfo.type.value,
        ein: dInfo.ein,
        contact_name: dInfo.contact_name,
        contact_phone: dInfo.contact_phone,
        contact_email: dInfo.contact_email
      }
      if (this.storeSelect.value) data.store_id = this.storeSelect.value
      if (this.up) {
        this.upDesignated(data)
      } else {
        this.crDesignated(data)
      }
    },
    upDesignated (data) {

    },
    crDesignated (data) {
      const self = this
      const url = '/brand/' + this.brandSelect.value + '/designatedUnit'
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.$router.replace('/designatedTable')
        }
      })
    },
    setStore () {
      var self = this
      let brands = this.info.attend_stores
      if (brands.length) {
        brands.forEach(function (brand) {
          brand.store_list.forEach(function (store) {
            self.addStoresSetting.choose.push(store.store_id)
          })
        })
      }
    },
    calculate (product) {
      var ones = product % 10
      var tens = (product - ones) / 10
      return ones + tens
    }
  },
  computed: {
    ...mapGetters(['getRoleType']),
    checkEin () {
      var ein = this.designated.ein
      var einN = []
      var validateOperator = [1, 2, 1, 2, 1, 2, 4, 1]
      if (this.designated.ein) {
        if (ein.length === 8) {
          for (var i = 0; i < ein.length; i++) {
            einN.push(parseInt(ein[i], 10))
          }
          var sum = 0
          for (var j = 0; j < validateOperator.length; j++) {
            sum += this.calculate(einN[j] * validateOperator[j])
          }
          if (sum % 10 === 0) {
            // 非營利事業統編
            return false
          } else {
            // 營利事業統編
            if (einN[6] === 7 && (sum + 1) % 10 === 0) {
              return false
            } else {
              return true
            }
          }
        } else {
          return true
        }
      } else return false
    },
    getDataH () {
      return this.$parent.getDataH
    },
    getData () {
      return this.$parent.getData
    }
  },
  watch: {
    'info.id' () {
      if (!this.setInfoTimes) this.setInfo()
    },
    'brandSelect.value' () {
      if (this.designated.owner.value !== 2) this.storeSelect = { label: '全部', value: 0 }
      else this.storeSelect = {}
    },
    'designated.owner.value' () {
      let isAll = this.addStoresSetting.options.find(function (store) { return store.value === 0 })
      if (this.designated.owner.value === 2) {
        if (isAll) this.addStoresSetting.options.splice(0, 1)
        if (this.storeSelect.value === 0) this.storeSelect = {}
      } else {
        if (typeof isAll === 'undefined') this.addStoresSetting.options.splice(0, 0, { label: '全部', value: 0 })
      }
    }
  }
}
</script>
<style lang="sass">
.coupon-left
  float: left
  width: calc(100% / 3 * 2 + 15px)
  padding-right: 5px
.coupon-right
  float: left
  background: #3c8dbc
  width: calc(100% / 3 - 15px)
  position: absolute
  right: 0
  top: 0
  height: 100%
  border-left: 5px black dashed
  border-radius: 0px 6px 6px 0px
  color: white
  .v-middle
    position: absolute
    top: calc(50% - 28.5px)
    font-size: 40px
    text-align: center
    width: 100%
    left: 0
</style>
<style lang="sass" scoped>
// .ranges
  display: none
.coupon.form-left, .coupon.form-right
  width: 50%
  float: left
.coupon.form-right
  padding: 20px 20px 20px 10px
.coupon.form-left
  padding: 20px 10px 20px 20px
.coupon.form-left.w-100-p
  padding: 20px 20px
.min-item.active, .hour-item.active, .day.checked
  background: #222d32 !important
.w-200
  width: 180px !important
.m-b-15
  margin-bottom: 15px !important
.btn-all-store
  position: absolute
  right: 10px
  z-index: 30
  top: 0px
.input-white
  border: 0px
@media screen and (max-width: 767px)
  .p-sm-10-p
    padding-right: 10px !important
    padding-left: 10px !important
@media screen and (min-width: 768px)
  .p-sm-10-p
    padding-right: calc(20% - 15px) !important
    padding-left: calc(20% + 10px) !important
@media screen and (min-width: 991px)
  .p-sm-10-p
    padding-right: calc(10% - 10px) !important
    padding-left: 10% !important
</style>
<style lang="sass">
  .multiselect__content-wrapper, .multiselect__content-wrapper *
    z-index: 99
  .m-t-0
    margin-top: 0px
  .input-group .form-control
    z-index: auto !important
  textarea
    max-width: 100%
    min-widht: 100%
  .modal-title
    width: calc(100% - 20px)
  @media screen and (max-width: 767px)
    .input-group.cr-schedule .cov-vue-date .cov-datepicker
      width: calc(100vw - 185px)
  @media screen and (min-width: 768px)
    .input-group.cr-schedule .cov-vue-date .cov-datepicker
      width: calc(50vw - 190px)
  @media screen and (min-width: 991px)
    .input-group .cov-vue-date .cov-datepicker
      max-width: calc(30vw - 190px)
</style>



// WEBPACK FOOTER //
// designatedForm.vue?2187679b